import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-campanii" }
const _hoisted_2 = { class: "contact-cell" }
const _hoisted_3 = { class: "contact-name" }
const _hoisted_4 = { class: "picker-main-container" }
const _hoisted_5 = { class: "picker-grid-wrapper" }
const _hoisted_6 = { class: "picker-contact-cell" }
const _hoisted_7 = { class: "contact-avatar-small" }
const _hoisted_8 = { class: "contact-name-info" }
const _hoisted_9 = { class: "primary-name" }
const _hoisted_10 = { class: "secondary-info" }
const _hoisted_11 = { class: "company-cell-info" }
const _hoisted_12 = { class: "mkt-consent-wrapper" }
const _hoisted_13 = { class: "picker-footer-modern" }
const _hoisted_14 = { class: "selection-info" }
const _hoisted_15 = {
  key: 0,
  class: "selection-pill animate-in"
}
const _hoisted_16 = {
  key: 1,
  class: "no-selection-text"
}
const _hoisted_17 = { class: "footer-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsMembers,
      allowColumnReordering: true,
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-column-lines": false,
      "hover-state-enabled": true,
      "remote-operations": true,
      class: "grid theme-dependent"
    }, {
      contactTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "dx-icon-user" }, null, -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(data.data.Contact?.Nume) + " " + _toDisplayString(data.data.Contact?.Prenume), 1)
        ])
      ]),
      statusTemplate: _withCtx(({ data }) => [
        _createElementVNode("span", {
          class: _normalizeClass('status-badge-' + data.value)
        }, _toDisplayString(data.value === 0 ? 'În așteptare' : (data.value === 1 ? 'Trimis' : 'Eroare')), 3)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxPaging, { "page-size": 10 }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxLoadPanel, { enabled: true }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Caută membru..."
        }),
        _createVNode(_component_DxEditing, { "allow-deleting": true }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "plus",
                  type: "default",
                  text: "Adaugă Membri",
                  onClick: _ctx.onOpenContactPicker
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "email",
                  type: "success",
                  text: "Lansează Trimitere",
                  onClick: _ctx.onLaunchCampaign
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Contact.Nume",
          "cell-template": "contactTemplate",
          caption: "Nume Contact"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Contact.Account.Nume",
          caption: "Partener"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Contact.TelMobil",
          caption: "Telefon"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Contact.Email",
          caption: "Email"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataAdaugarii",
          caption: "Data Adăugării",
          "data-type": "date",
          format: "dd/MM/yyyy"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "StatusTrimitere",
          caption: "Status",
          "cell-template": "statusTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataTrimitere",
          caption: "Data Trimiterii",
          "data-type": "date",
          format: "dd/MM/yyyy HH:mm"
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isContactPickerVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isContactPickerVisible) = $event)),
      width: 900,
      height: 700,
      "show-close-button": true,
      onShowing: _ctx.onPickerShowing,
      "drag-enabled": true,
      position: "center",
      class: "premium-popup"
    }, {
      title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "premium-popup-header" }, [
          _createElementVNode("div", { class: "header-icon-wrapper" }, [
            _createElementVNode("i", { class: "dx-icon-group" })
          ]),
          _createElementVNode("div", { class: "header-text" }, [
            _createElementVNode("span", { class: "header-title" }, "Selectează Membri Campanie"),
            _createElementVNode("span", { class: "header-subtitle" }, "Alege contactele eligibile pentru această campanie marketing")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsAllContacts,
              allowColumnReordering: true,
              allowColumnResizing: true,
              "key-expr": "ID",
              columnAutoWidth: true,
              "show-borders": false,
              syncLookupFilterValues: false,
              "filter-sync-enabled": true,
              "show-column-lines": false,
              "hover-state-enabled": true,
              "remote-operations": true,
              height: "500",
              class: "picker-grid modern-grid",
              onSelectionChanged: _ctx.onSelectionChanged
            }, {
              contactNameTemplate: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString((data.data.Nume?.[0] || '') +
                                    (data.data.Prenume?.[0]
                                        || '')), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(data.data.Nume) + " " + _toDisplayString(data.data.Prenume), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(data.data.TelMobil || 'Fara telefon'), 1)
                  ])
                ])
              ]),
              companyTemplate: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(data.data.Account?.Nume || '-'), 1)
                ])
              ]),
              mktTemplate: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_12, [
                  (data.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        color: "success",
                        size: "20"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-check-decagram", -1)
                        ]))]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        color: "grey-lighten-1",
                        size: "20"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("mdi-minus-circle-outline", -1)
                        ]))]),
                        _: 1
                      }))
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_DxSelection, {
                  mode: "multiple",
                  "show-check-boxes-mode": "always"
                }),
                _createVNode(_component_DxFilterRow, { visible: true }),
                _createVNode(_component_DxSearchPanel, {
                  visible: true,
                  placeholder: "Caută după nume, partener sau email..."
                }),
                _createVNode(_component_DxPaging, { "page-size": 10 }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Nume",
                  "cell-template": "contactNameTemplate"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Account.Nume",
                  caption: "Partener",
                  "cell-template": "companyTemplate"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "EmailMarketing",
                  caption: "Email",
                  "data-type": "boolean",
                  width: "80",
                  "cell-template": "mktTemplate",
                  alignment: "center"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "SmsMarketing",
                  caption: "SMS",
                  "data-type": "boolean",
                  width: "80",
                  "cell-template": "mktTemplate",
                  alignment: "center"
                })
              ]),
              _: 1
            }, 8, ["data-source", "onSelectionChanged"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_ctx.selectedContactIds.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_v_icon, {
                      color: "white",
                      size: "16",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-account-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedContactIds.length) + " contacte selectate", 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, "Selectează contacte din listă pentru a le adăuga în campanie"))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_DxButton, {
                text: "Anulează",
                "styling-mode": "outlined",
                type: "normal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isContactPickerVisible = false)),
                class: "modern-btn"
              }),
              _createVNode(_component_DxButton, {
                text: "Adaugă în Campanie",
                type: "success",
                onClick: _ctx.addSelectedContacts,
                width: "210",
                disabled: !_ctx.selectedContactIds.length,
                class: "modern-btn primary-btn",
                icon: "plus"
              }, null, 8, ["onClick", "disabled"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onShowing"])
  ]))
}